import { useListCampaignsQuery } from 'api/offers-domain/offers-domain';
import AutocompleteField, {
  AutocompleteFieldProps,
} from 'components/forms/fields/autocomplete-field/autocomplete-field.component';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export type CampaignFieldProps = {
  isexpired?: boolean | undefined;
} & Partial<AutocompleteFieldProps>;

const CampaignField = ({
  isexpired = undefined,
  ...rest
}: CampaignFieldProps) => {
  const { t } = useTranslation();
  const { data } = useListCampaignsQuery({
    count: 1000,
    page: 0,
    isexpired,
  });

  const campaignOptions = useMemo(
    () =>
      data?.campaigns?.map(campaign => ({
        id: campaign.campaignId,
        label: campaign.title,
        programId: campaign.programId,
      })),
    [data?.campaigns],
  );

  return (
    <AutocompleteField
      isOptionEqualToValue={(option, value) => option?.id === value}
      name={'campaign'}
      options={campaignOptions}
      label={t('CampaignField.label')}
      {...rest}
    />
  );
};

export default CampaignField;
